import { StoryNodeDisplayType } from "../../../../storyV2/domain/StoryNodeDisplayType";
import { Handler } from "../chain/TransformServiceHandlerChain";
import { tryPromise } from "../../../../cutil/LangUtil";
import { Meta } from "../../../../cutil/Meta";
import isBlank from "@sedan-utils/is-blank";
export class WSHandler extends Handler {
    constructor(brainClient) {
        super();
        this.brainClient = brainClient;
    }
    async process(request) {
        /// 用于处理 WS 数据，非 WS 数据，不处理
        if (!request.isWS) {
            return false;
        }
        const displayType = request.displayType;
        switch (displayType) {
            case StoryNodeDisplayType.UPLOADIMAGE:
            case StoryNodeDisplayType.AUDIO:
            case StoryNodeDisplayType.VIDEO:
            case StoryNodeDisplayType.PDFFILE:
                if (request.websocketFileParams?.file_url && !isBlank(request.websocketFileParams.file_url)) {
                    const res = await tryPromise(this.brainClient.global.request(request.websocketFileParams.file_url, request.websocketFileParams?.method || "get", request.websocketFileParams?.headers || undefined, request.websocketFileParams?.body || undefined));
                    /// 更新 response 继续处理后续内容
                    request.updateResponse(res.data);
                    return false;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            case StoryNodeDisplayType.HTML:
                if (request.websocketHtml) {
                    return false;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            case StoryNodeDisplayType.TEXT:
                if (request.websocketContent) {
                    request.setResult(request.websocketContent);
                    return true;
                }
                /// 如果未正确返回数据，抛出错误
                throw WSHandler.contentError;
            default:
                return false;
        }
    }
}
WSHandler.contentError = new Meta("WSHandler Error", "Got content faild");
